import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Exceptional Benefits of Developing a <span>Telehealth App</span>{" "}
              for Patient Care
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              Today, healthcare is more advanced than ever before. Because of
              this, a telemedicine app development company comes as a perfect
              option to transform the whole process of patient care and health
              services. Through the use of technology, telehealth apps help
              healthcare providers in the provision of time-saving, effective,
              and personalized healthcare services to patients no matter where
              they are. From remote consultations to following the chronic
              disease course, these apps enable patients to be more active
              participants in the entire health and wellness journey and to
              strive for better outcomes.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Improved Healthcare Access</h6>
                <p>
                  With telemedicine apps, distant patients are no longer an
                  issue, since they can easily access medical services from
                  their homes.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Better Convenience & Flexibility</h6>
                <p>
                  Patients can schedule appointments, hold consultations with
                  doctors, and check vital medical records from anywhere at any
                  time.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Timely Intervention & Monitoring</h6>
                <p>
                  Telemedicine apps allow for prompt intervention and remote
                  monitoring of chronic disease, which makes it easier for
                  healthcare providers.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Cost-Effective Healthcare Delivery</h6>
                <p>
                  By minimizing the necessity of face-to-face meetings and
                  visits to hospitals, telehealth apps eventually help patients
                  receive lower costs of healthcare.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Improved Patient Engagement</h6>
                <p>
                  Patients engaged in their treatment by telemedicine apps,
                  accessing educational stuff, medication reminders, and
                  personalized health data.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Personalized Care Plans</h6>
                <p>
                  Telehealth apps facilitate individualized care schemes
                  particular to every patient, leading to more successful
                  treatments, while the patient with the disease driving the
                  disease treatment remains central.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
